<mg-button
  [disabled]="disabled"
  [disableRipple]="true"
  [active]="active"
  [type]="_type"
  [attr.color]="color">
  <ng-content></ng-content>
</mg-button>
